import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { SlidesImportMode } from 'src/app/models/slides-import.models';
import { SVGIconComponentsModule } from 'src/app/common/svg-icon/svg-icon-components.module';
import {
  ModalTemplateComponent,
  PencilModalSizeEnum,
} from 'src/app/standalones/components/modals/modal-template/modal-template.component';

@Component({
  selector: 'app-slides-import-mode-dialog',
  templateUrl: './slides-import-mode-dialog.component.html',
  styleUrls: ['./slides-import-mode-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TranslateModule, SVGIconComponentsModule, ModalTemplateComponent],
})
export class SlidesImportModeDialogComponent {
  readonly SlidesImportMode = SlidesImportMode;
  readonly PencilModalSizeEnum = PencilModalSizeEnum;

  constructor(private readonly dialogRef: MatDialogRef<SlidesImportModeDialogComponent>) {}

  onSelectMode(mode: SlidesImportMode): void {
    this.dialogRef.close({ mode });
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }
}
